import React, { useRef, useEffect, useState } from 'react';
import '../components/label.css';

function CustomInputBox({
  value,
  onBlur,
  label,
  onChange,
  placeholder,
  sum,
  lumpSum,
  policyTerm,
  validationType,
}) {
  const inputRef = useRef();
  const [inputValue, setInputValue] = useState(value);
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    const handleInputBlur = () => {
      onBlur(inputRef.current.value);
    };

    const handleEnterKeyPress = (event) => {
      if (event.keyCode === 13) {
        handleInputBlur();
      }
    };

    setInputValue(value);

    inputRef?.current?.addEventListener('blur', handleInputBlur);
    inputRef?.current?.addEventListener('keydown', handleEnterKeyPress);

    return () => {
      inputRef?.current?.removeEventListener('blur', handleInputBlur);
      inputRef?.current?.removeEventListener('keydown', handleEnterKeyPress);
    };
  }, [onBlur, value]);

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);

    // Allow Enter key
    if (charCode === 13) return;

    const positiveIntegerRegex = /^[0-9]+$/;

    // Prevent anything that's not a number
    if (!positiveIntegerRegex.test(char)) {
      event.preventDefault();
    }
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;

    // Allow clearing the input
    if (newValue === '') {
      setInputValue('');
      if (typingTimeout) clearTimeout(typingTimeout);
      onChange('');
      return;
    }

    // Disallow values with leading zeros like "01", "002"
    if (/^0\d+/.test(newValue)) {
      return;
    }

    // Block typing if number exceeds policyTerm
    const numericVal = Number(newValue);

    if (validationType === 'ppt' && numericVal > policyTerm) {
      // Prevent input (do NOT update state or call onChange)
      return;
    }

    // Allow only positive integers
    const positiveIntegerRegex = /^[0-9]+$/;
    if (positiveIntegerRegex.test(newValue)) {
      setInputValue(newValue);

      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      // Set a new timeout for API call after 1600ms of inactivity
      setTypingTimeout(
        setTimeout(() => {
          onChange(newValue);
        }, 1600)
      );
    }
  };

  return (
    <>
      <label className="labelUpper">{label}</label>
      <input
        ref={inputRef}
        type="text"
        className={sum ? 'inputBoxSum custom-input' : 'custom-input'}
        value={inputValue}
        placeholder={placeholder}
        onKeyPress={handleKeyPress}
        onChange={handleInputChange}
      />
    </>
  );
}

export default CustomInputBox;